import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

const ThemedContentLoader = (props) => {
  const theme = useTheme();
  return (
    <ContentLoader
      {...props}
      backgroundColor={theme.skeleton}
      foregroundColor={theme.skeletonShine}
    />
  );
};

export default ThemedContentLoader;
